export default class ContractBasicInfoModel {
    idContrato: number;
    cancelado: boolean;
    categoria: string;
    nome: string;
    cpf: string;

    constructor(
        idContrato: number,
        cancelado: boolean,
        categoria: string,
        nome: string,
        cpf: string
    ) {
        this.idContrato = idContrato;
        this.cancelado = cancelado;
        this.categoria = categoria;
        this.nome = nome;
        this.cpf = cpf;
    }

    static fromApiResponse(data: any): ContractBasicInfoModel[] {
        return data.map((item: any) => new ContractBasicInfoModel(
            item.id_contrato,
            item.cancelado,
            item.categoria,
            item.nome,
            item.cpf
        ));
    }

    static fromSingleApiResponse(data: any): ContractBasicInfoModel {
        return new ContractBasicInfoModel(
            data.id_contrato,
            data.cancelado,
            data.categoria,
            data.nome,
            data.cpf
        );
    }
}
